module.exports = __webpack_public_path__ + "n.no2.755e265b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/n.no2.jpg
// module id = uUcb
// module chunks = 0